<template>
    <b-modal
        v-model="modal"
        v-if="internship"
        modal-class="apprentice-default-modal internship-status-update-feedback-modal"
        :id="`update-internship-modal-${internship.id}`"
        size="md"
        :title="$t('group.internship.reject_and_reopen_internship')"
        :ok-title="$t('common.save')"
        @ok="storeStatus"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')">
        <div class="internship-status-edit">
            <div
                class="errors"
                v-if="hasError">
                <b-alert
                    variant="danger"
                    show>
                    {{ $t('group.internship.feedback_field_is_a_mandatory_field') }}
                </b-alert>
            </div>
            <div class="description">
                {{ $t('group.internship.please_provide_the_reason_for_rejecting_reopening_the_internship_below') }}
            </div>

            <b-form-group>
                <label for="internship-status-update-feedback-textarea">Feedback <span class="required"></span></label>
                <b-form-textarea
                    class="apprentice-textarea"
                    id="internship-status-update-feedback-textarea"
                    v-model="feedback"
                    rows="4"
                    :placeholder="$t('group.internship.give_your_feedback')">
                </b-form-textarea>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-show-reject-internship-modal-component',
    data() {
        return {
            modal: false,
            internship: {},
            feedback: '',
            hasError: false,
        };
    },

    methods: {
        show(internship) {
            this.modal = true;
            this.internship = internship;
            this.feedback = '';
            this.hasError = false;
        },

        storeStatus(bvModalEvent) {
            this.hasError = false;

            if (this.feedback === '') {
                this.hasError = true;
                bvModalEvent.preventDefault();
                return;
            }

            const data = {
                internshipId: this.internship.id,
                projectId: this.internship.pivot.project_id,
                feedback: this.feedback,
            };

            this.alert.saving();
            this.axios.post(this.routes.internshipRejectStudent(), data).then(
                (response) => {
                    this.$emit('rejected', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.description {
    margin-bottom: $grid-gutter-width;
    color: $text-muted-color;
    font-size: $base-font-size;
    font-weight: $font-weight-medium;
}
</style>
